"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FinancialsView = void 0;
const React = require("react");
const ReactTooltip = require("react-tooltip");
const moment = require("moment");
const material_ui_icons_1 = require("material-ui-icons");
const core_1 = require("@material-ui/core");
const material_ui_1 = require("material-ui");
const claim_1 = require("shared/claim");
const financial_widget_1 = require("client/modules/dashboard/modules/widget-grid/components/financial-widget");
const financials_card_1 = require("client/modules/financial/modules/financials-view/components/financials-card");
const financials_header_1 = require("client/modules/financial/modules/financials-view/components/financials-header");
const floating_page_1 = require("client/components/page/floating-page");
const kpi_header_1 = require("client/components/kpi-header");
const kpi_title_1 = require("client/components/kpi-header/kpi-title");
const button_1 = require("client/components/material/button");
// import { inventoryListStore } from "client/modules/inventory/modules/inventory-list/store";
// import { sitesListStore } from "client/modules/sites/modules/sites-list/store";
const store_1 = require("client/modules/financial/store");
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const store_2 = require("client/modules/users/store");
const styles = core_1.createStyles({
    bgPrimary: {
        background: "#39923d"
    },
    bgSecondary: {
        background: "#343fbf"
    },
    buttonContainer: {
        "& > button": {
            background: "#e4e4e4"
        },
        "@media only screen and (max-width: 650px)": {
            gridTemplateColumns: "repeat(1, 1fr)"
        },
        // eslint-disable-next-line sort-keys-fix/sort-keys-fix
        "@media only screen and (max-width: 1000px)": {
            gridTemplateColumns: "repeat(2, 1fr)"
        },
        "@media only screen and (max-width: 1400px)": {
            gridTemplateColumns: "repeat(3, 1fr)"
        },
        "display": "grid",
        "gridGap": ".5rem",
        "gridTemplateColumns": "repeat(5, 1fr)",
        "justifyContent": "space-between",
        "marginTop": "1rem"
    },
    cardsContainer: {
        alignItems: "center",
        display: "grid",
        gridGap: "1rem",
        gridTemplateColumns: "1fr",
        justifyContent: "space-around"
    },
    divider: {
        backgroundColor: "#d2d7e2",
        height: "5rem"
    },
    fontPrimary: {
        color: "#fff"
    },
    fontSecondary: {
        color: "#000"
    },
    graphContainer: {
        margin: "1rem 0"
    },
    mainCards: {
        "@media only screen and (max-width: 1280px)": {
            gridTemplateColumns: "repeat(1, 1fr)"
        },
        "display": "grid",
        "gridGap": "1rem",
        "gridTemplateColumns": "repeat(2, 1fr)"
    },
    root: {
        padding: "1rem"
    },
    subCards: {
        "@media only screen and (max-width: 1280px)": {
            gridTemplateColumns: "repeat(2, 1fr)"
        },
        "display": "grid",
        "gridGap": "1rem",
        "gridTemplateColumns": "repeat(4, 1fr)"
    }
});
const decorate = core_1.withStyles(styles);
let FinancialsViewUnstyled = class FinancialsViewUnstyled extends React.Component {
    constructor() {
        super(...arguments);
        this.siteId = 0;
        this.showPreviousPeriod = false;
        this.periodDateRange = "";
        this.prevPeriodDateRange = "";
        this.startDate = "";
        this.endDate = "";
        this.prevStartDate = "";
        this.prevEndDate = "";
        this.periodData = {
            dispenses: 0,
            fees: 0,
            orders: 0,
            patientRefusals: 0,
            productionPotential: 0,
            productionRevenue: 0
        };
        this.prevPeriodData = {
            dispenses: 0,
            fees: 0,
            orders: 0,
            patientRefusals: 0,
            productionPotential: 0,
            productionRevenue: 0
        };
        this.renderFinancialsCards = () => {
            const { productionRevenue, productionPotential, dispenses, fees, orders, patientRefusals } = this.periodData;
            const { classes: { bgPrimary, bgSecondary, cardsContainer, fontPrimary, mainCards, subCards } } = this.props;
            const queryDispenses = {
                endDate: this.endDate,
                siteId: this.siteId,
                startDate: this.startDate,
                status: claim_1.ClaimStatus.Dispensed
            };
            const queryOrders = {
                endDate: this.endDate,
                siteId: this.siteId,
                startDate: this.startDate
            };
            return (React.createElement("div", { className: cardsContainer },
                React.createElement("div", { className: mainCards },
                    React.createElement(financials_card_1.FinancialsCard, { bgColor: bgPrimary, fontColor: fontPrimary, title: "Production Revenue", icon: React.createElement(material_ui_icons_1.AccountBalance, null), data: productionRevenue }),
                    React.createElement(financials_card_1.FinancialsCard, { bgColor: bgSecondary, fontColor: fontPrimary, title: "Production Potential", icon: React.createElement(material_ui_icons_1.TrendingUp, null), data: productionPotential })),
                React.createElement("div", { className: subCards },
                    React.createElement(financials_card_1.FinancialsCard, { bgColor: bgPrimary, fontColor: fontPrimary, title: "Dispenses", icon: React.createElement(material_ui_icons_1.Send, null), data: dispenses, to: "/reports/claim-analytics", query: queryDispenses }),
                    React.createElement(financials_card_1.FinancialsCard, { bgColor: bgPrimary, fontColor: fontPrimary, title: "Fees", icon: React.createElement(material_ui_icons_1.MoneyOff, null), data: fees }),
                    React.createElement(financials_card_1.FinancialsCard, { bgColor: bgSecondary, fontColor: fontPrimary, title: "Orders", icon: React.createElement(material_ui_icons_1.ShoppingCart, null), data: orders, to: "/reports/order-analytics", query: queryOrders }),
                    React.createElement(financials_card_1.FinancialsCard, { bgColor: bgSecondary, fontColor: fontPrimary, title: "Patient Refusals", icon: React.createElement(material_ui_icons_1.ThumbDown, null), data: patientRefusals }))));
        };
        this.renderFinancialsGraph = () => {
            const { classes: { graphContainer } } = this.props;
            return (React.createElement("div", { className: graphContainer },
                React.createElement(material_ui_1.Card, null,
                    React.createElement(financial_widget_1.FinancialWidget, { isFinancialPage: true, periodData: this.periodData, prevPeriodData: this.prevPeriodData, payPeriod: this.periodDateRange, prevPayPeriod: this.prevPeriodDateRange }))));
        };
        this.renderReports = () => {
            const { classes: { buttonContainer } } = this.props;
            return (React.createElement("div", { className: buttonContainer },
                store_2.usersStore.permissions.ReadClaimAnalytics && (React.createElement(button_1.MaterialButton, { to: "/reports/claim-analytics", flat: true, secondary: true }, "Claim Analytics")),
                store_2.usersStore.permissions.ReadOrderAnalytics && (React.createElement(button_1.MaterialButton, { to: "/reports/order-analytics", flat: true, secondary: true }, "Order Analytics")),
                store_2.usersStore.permissions.ReadClinicReimb && (React.createElement(button_1.MaterialButton, { to: "/reports/clinic-reimbursement", flat: true, secondary: true }, "Clinic Reimbursement")),
                store_2.usersStore.permissions.ReadNegativeBalances && (React.createElement(button_1.MaterialButton, { to: "reports/negative-balances", flat: true, secondary: true }, "Negative Balances")),
                store_2.usersStore.permissions.ReadARAgingReport && (React.createElement(button_1.MaterialButton, { to: "reports/ar-aging-report", flat: true, secondary: true }, "A/R Aging Report"))));
        };
        this.renderMain = () => {
            const { classes: { root } } = this.props;
            return (React.createElement("div", { className: root },
                this.renderFinancialsCards(),
                this.renderFinancialsGraph(),
                store_2.usersStore.permissions.ReadReports && (React.createElement(financials_header_1.FinancialsHeader, { icon: React.createElement(material_ui_icons_1.GridOn, null), headline: "Reports" })),
                store_2.usersStore.permissions.ReadReports && this.renderReports()));
        };
        this.handlePeriodToggle = () => {
            this.showPreviousPeriod = !this.showPreviousPeriod;
        };
        this.handleChangePeriod = async (query) => {
            var _a, _b, _c, _d, _e, _f;
            this.startDate = query.startDate;
            this.endDate = query.endDate;
            const startDate = moment(query.startDate).format("MM/DD/YYYY");
            const endDate = moment(query.endDate).format("MM/DD/YYYY");
            this.periodDateRange = startDate.concat(" - ", endDate);
            let prevEndDate = "";
            let prevStartDate = "";
            if (moment(this.startDate).date() === 1) {
                const currentStartDate = moment(this.startDate);
                this.prevEndDate = moment(this.startDate)
                    .subtract(1, "days")
                    .format("YYYY-MM-DD");
                this.prevStartDate = moment(this.startDate)
                    .subtract(1, "months")
                    .add(15, "days")
                    .format("YYYY-MM-DD");
                prevEndDate = moment(this.startDate)
                    .subtract(1, "days")
                    .format("MM/DD/YYYY");
                prevStartDate = moment(this.startDate)
                    .subtract(1, "months")
                    .add(15, "days")
                    .format("MM/DD/YYYY");
            }
            if (moment(this.startDate).date() === 16) {
                const currentStartDate = moment(this.startDate);
                this.prevEndDate = moment(this.startDate)
                    .subtract(1, "days")
                    .format("YYYY-MM-DD");
                this.prevStartDate = moment(this.startDate)
                    .startOf("month")
                    .format("YYYY-MM-DD");
                prevEndDate = moment(this.startDate)
                    .subtract(1, "days")
                    .format("MM/DD/YYYY");
                prevStartDate = moment(this.startDate)
                    .startOf("month")
                    .format("MM/DD/YYYY");
            }
            this.prevPeriodDateRange = prevStartDate.concat(" - ", prevEndDate);
            // console.log("previous start and end dates in handle change period", this.prevStartDate, this.prevEndDate, this.prevPeriodDateRange);
            const data = await store_1.financialsStore.getPeriodData(this.endDate, this.siteId, this.startDate);
            this.prevPeriodData = await store_1.financialsStore.getPeriodData(this.prevEndDate, this.siteId, this.prevStartDate);
            this.periodData.dispenses = (_a = data === null || data === void 0 ? void 0 : data.dispenses) !== null && _a !== void 0 ? _a : 0;
            this.periodData.fees = (_b = data === null || data === void 0 ? void 0 : data.fees) !== null && _b !== void 0 ? _b : 0;
            this.periodData.orders = (_c = data === null || data === void 0 ? void 0 : data.orders) !== null && _c !== void 0 ? _c : 0;
            this.periodData.patientRefusals = (_d = data === null || data === void 0 ? void 0 : data.patientRefusals) !== null && _d !== void 0 ? _d : 0;
            this.periodData.productionPotential = (_e = data === null || data === void 0 ? void 0 : data.productionPotential) !== null && _e !== void 0 ? _e : 0;
            this.periodData.productionRevenue = (_f = data === null || data === void 0 ? void 0 : data.productionRevenue) !== null && _f !== void 0 ? _f : 0;
        };
        this.handleChangeSite = async (siteId) => {
            var _a, _b, _c, _d, _e, _f;
            this.siteId = siteId;
            const data = await store_1.financialsStore.getPeriodData(this.endDate, this.siteId, this.startDate);
            this.prevPeriodData = await store_1.financialsStore.getPeriodData(this.prevEndDate, this.siteId, this.prevStartDate);
            this.periodData.dispenses = (_a = data === null || data === void 0 ? void 0 : data.dispenses) !== null && _a !== void 0 ? _a : 0;
            this.periodData.fees = (_b = data === null || data === void 0 ? void 0 : data.fees) !== null && _b !== void 0 ? _b : 0;
            this.periodData.orders = (_c = data === null || data === void 0 ? void 0 : data.orders) !== null && _c !== void 0 ? _c : 0;
            this.periodData.patientRefusals = (_d = data === null || data === void 0 ? void 0 : data.patientRefusals) !== null && _d !== void 0 ? _d : 0;
            this.periodData.productionPotential = (_e = data === null || data === void 0 ? void 0 : data.productionPotential) !== null && _e !== void 0 ? _e : 0;
            this.periodData.productionRevenue = (_f = data === null || data === void 0 ? void 0 : data.productionRevenue) !== null && _f !== void 0 ? _f : 0;
        };
    }
    async componentDidMount() {
        var _a, _b, _c, _d, _e, _f;
        ReactTooltip.rebuild();
        const today = moment([]).startOf("day");
        const endDate = moment(today).format("MM/DD/YYYY");
        this.endDate = moment(today).format("YYYY-MM-DD");
        if (moment(today).date() < 16) {
            const startDate = moment(today)
                .startOf("month")
                .format("MM/DD/YYYY");
            this.startDate = moment(today)
                .startOf("month")
                .format("YYYY-MM-DD");
            // this.startDate = "2020-01-01"; // for test only - revert to line above before commit
            this.periodDateRange = startDate.concat(" - ", endDate);
        }
        else {
            const currentMonth = moment(today).format("MM");
            const currentYear = moment(today).format("YYYY");
            const startDate = currentMonth.concat("/16/", currentYear);
            this.startDate = currentYear.concat("-", currentMonth, "-16");
            this.periodDateRange = startDate.concat(" - ", endDate);
        }
        let prevStartD;
        let prevEndD;
        if (moment(this.startDate).date() === 1) {
            const currentStartDate = moment(this.startDate);
            this.prevEndDate = moment(this.startDate)
                .subtract(1, "days")
                .format("YYYY-MM-DD");
            this.prevStartDate = moment(this.startDate)
                .subtract(1, "months")
                .add(15, "days")
                .format("YYYY-MM-DD");
            prevEndD = moment(this.startDate)
                .subtract(1, "days")
                .format("MM/DD/YYYY");
            prevStartD = moment(this.startDate)
                .subtract(1, "months")
                .add(15, "days")
                .format("MM/DD/YYYY");
        }
        if (moment(this.startDate).date() === 16) {
            const currentStartDate = moment(this.startDate);
            this.prevEndDate = moment(this.startDate)
                .subtract(1, "days")
                .format("YYYY-MM-DD");
            this.prevStartDate = moment(this.startDate)
                .startOf("month")
                .format("YYYY-MM-DD");
            prevEndD = moment(this.startDate)
                .subtract(1, "days")
                .format("MM/DD/YYYY");
            prevStartD = moment(this.startDate)
                .startOf("month")
                .format("MM/DD/YYYY");
        }
        this.prevPeriodDateRange = prevStartD.concat(" - ", prevEndD);
        // console.log("previous start and end dates in comp did mount", this.prevStartDate, this.prevEndDate, this.prevPeriodDateRange);
        const { siteId } = store_2.usersStore.user.value;
        if (siteId) {
            this.siteId = siteId;
        }
        const data = await store_1.financialsStore.getPeriodData(this.endDate, siteId, this.startDate);
        this.prevPeriodData = await store_1.financialsStore.getPeriodData(this.prevEndDate, siteId, this.prevStartDate);
        this.periodData.dispenses = (_a = data === null || data === void 0 ? void 0 : data.dispenses) !== null && _a !== void 0 ? _a : 0;
        this.periodData.fees = (_b = data === null || data === void 0 ? void 0 : data.fees) !== null && _b !== void 0 ? _b : 0;
        this.periodData.orders = (_c = data === null || data === void 0 ? void 0 : data.orders) !== null && _c !== void 0 ? _c : 0;
        this.periodData.patientRefusals = (_d = data === null || data === void 0 ? void 0 : data.patientRefusals) !== null && _d !== void 0 ? _d : 0;
        this.periodData.productionPotential = (_e = data === null || data === void 0 ? void 0 : data.productionPotential) !== null && _e !== void 0 ? _e : 0;
        this.periodData.productionRevenue = (_f = data === null || data === void 0 ? void 0 : data.productionRevenue) !== null && _f !== void 0 ? _f : 0;
    }
    componentDidUpdate() {
        ReactTooltip.rebuild();
    }
    render() {
        ReactTooltip.rebuild();
        return (React.createElement(React.Fragment, null, store_2.usersStore.permissions.ReadFinancials ? ( // D-002.71 
        React.createElement("div", { className: "inventory-list inventory-list--formulary-custom" },
            React.createElement(kpi_header_1.KpiHeader, { center: false, noDivider: true },
                React.createElement("div", { className: "inventory-list__title-wrapper" },
                    React.createElement(kpi_title_1.KpiTitle, { label: "Financials" }))),
            React.createElement(floating_page_1.FloatingPage, null,
                React.createElement(financials_header_1.FinancialsHeader, { icon: React.createElement(material_ui_icons_1.DateRange, null), headline: this.periodDateRange, withSwitch: true, onChangePayPeriod: this.handleChangePeriod, onChangeSite: this.handleChangeSite }),
                this.renderMain()))) : (store_2.usersStore.showLock())));
    }
};
__decorate([
    mobx_1.observable
], FinancialsViewUnstyled.prototype, "siteId", void 0);
__decorate([
    mobx_1.observable
], FinancialsViewUnstyled.prototype, "showPreviousPeriod", void 0);
__decorate([
    mobx_1.observable
], FinancialsViewUnstyled.prototype, "periodDateRange", void 0);
__decorate([
    mobx_1.observable
], FinancialsViewUnstyled.prototype, "prevPeriodDateRange", void 0);
__decorate([
    mobx_1.observable
], FinancialsViewUnstyled.prototype, "startDate", void 0);
__decorate([
    mobx_1.observable
], FinancialsViewUnstyled.prototype, "endDate", void 0);
__decorate([
    mobx_1.observable
], FinancialsViewUnstyled.prototype, "prevStartDate", void 0);
__decorate([
    mobx_1.observable
], FinancialsViewUnstyled.prototype, "prevEndDate", void 0);
__decorate([
    mobx_1.observable
], FinancialsViewUnstyled.prototype, "periodData", void 0);
__decorate([
    mobx_1.observable
], FinancialsViewUnstyled.prototype, "prevPeriodData", void 0);
FinancialsViewUnstyled = __decorate([
    mobx_react_1.observer
], FinancialsViewUnstyled);
exports.FinancialsView = decorate(FinancialsViewUnstyled);



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/financial/modules/financials-view/financials-view.tsx
// module id = 3447
// module chunks = 0